export enum ItemTypeGroup {
  Labor = 'Labor',              // filter items with itemType == Service
  Expense = 'Expense',          // filter items that are expense type - inventory, non-inventory, bom
  Fee = 'Fee',
  None = 'None'                 // don't filter any itemType
}
